// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"12954a48","845":"7a41bfff"}[chunkId] + ".chunk.js";
};